export const allowClient = true
export const serverBasePath = "__api_party"

export const experimentalEnablePrefixedProxy = false
export const experimentalDisableClientPayloadCache = false
